import appflowLogo from './appflow-logo.svg';
import dropboxLogo from './dropbox-logo.svg';
import googleDriveLogo from './google-drive-logo.svg';
import awsRdsLogo from './aws-rds-logo.svg';
import postgresLogo from './postgres-logo.svg';
import restApiLogo from './rest-api-logo.svg';
import gsheetsLogo from './gsheets-logo.svg';
import fivetranLogo from './fivetran.svg';
import databricksLogo from './databricks-logo.svg';
import calendlyLogo from './calendly.svg';
import gmailLogo from './gmail.svg';
import googleCalendarLogo from './google-calendar.svg';
import googleDocsLogo from './google-docs.svg';
import oneDriveLogo from './one-drive.svg';
import outlookLogo from './outlook.svg';
import sharepointLogo from './sharepoint-icon.svg';
import slackLogo from './slack.svg';
import tavilyLogo from './tavily.svg';
import zoomLogo from './zoom.svg';
import teamsLogo from './teams.svg';
import googleLogo from './google.svg';
import excelLogo from './excel.svg';
import salesforceLogo from './salesforce.svg';

const logoMapping = {
	appflow: appflowLogo,
	dropbox: dropboxLogo,
	google: googleLogo,
	googleDrive: googleDriveLogo,
	awsRds: awsRdsLogo,
	postgres: postgresLogo,
	restApi: restApiLogo,
	gsheets: gsheetsLogo,
	fivetran: fivetranLogo,
	databricks: databricksLogo,
	calendly: calendlyLogo,
	gmail: gmailLogo,
	googleCalendar: googleCalendarLogo,
	googleDocs: googleDocsLogo,
	oneDrive: oneDriveLogo,
	outlook: outlookLogo,
	sharepoint: sharepointLogo,
	slack: slackLogo,
	tavily: tavilyLogo,
	teams: teamsLogo,
	zoom: zoomLogo,
	excel: excelLogo,
	salesforce: salesforceLogo
};

export default logoMapping;
